import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=498cb93d"
import script from "./Events.ts?vue&type=script&lang=ts&external"
export * from "./Events.ts?vue&type=script&lang=ts&external"
import style0 from "./Events.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports